// extracted by mini-css-extract-plugin
export default {"container":"dedupeReviewPage_container__9Om6z","section":"dedupeReviewPage_section__eUeoH","feedback":"dedupeReviewPage_feedback__oVrJh"};